// extracted by mini-css-extract-plugin
export default {"title":"LinkRelationalFlagsWindow_title__S+AX9"};